import React, { useState } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import './RefundPolicySection.css';

const refundPolicyData = [
  {
    title: 'Refund Policy',
    content: [
      'By accessing and using RSKPay, YOU accept and agree to the terms, conditions and rules without limitation and or qualification.',
      'We reserve the right to modify the terms at any time without giving YOU any prior notice. Your use of RSKPay following any such modification constitutes your agreement to follow and be bound by the terms as modified. Any additional terms and conditions, disclaimers, privacy policies and other policies applicable in general and/ or to specific areas of this website, RSKPay or to a particular service are also considered as terms.',
      'RSKPay does not at any point of time during any transaction between the USER and merchant/ vendor and or service provider take the ownership of any of the products/services provided by the merchant. Nor does RSKPay at any point asserts any rights or claims over the products/services offered by the merchant to the USER. The cancellation/refund, if any, will be governed as per the terms and conditions of the aggregator or of the merchant/vendor. RSKPay has no role in governing refund/cancellation charges. RSKPay, will not be responsible for refund/cancellation including any charges arising therefrom.',
      'In the event, YOU erroneously send a payment to a wrong party or have sent a payment for a wrong amount, RSKPay shall have no liability in this regard and your only recourse will be to contact such third party to whom such payment was sent and seek a refund (if any). RSKPay will not refund or reverse a payment erroneously made by YOU.',
      'All sales of prepaid recharge on the RSKPay platform are final with no refund or exchange permitted. YOU are responsible for the mobile number or dth account number for which YOU purchased the prepaid recharge and all charges that result from those purchases. YOU are also responsible for the information relating to data card and similar recharge services and all charges that result from those purchases. RSKPay is not responsible for any purchase of prepaid recharge for an incorrect mobile number or dth account number or incorrect data card information and or similar services.',
      'RSKPay disclaims any accountability, legal, losses/damages or else, that might arise because of the act, omission or otherwise of any USER on its website/mobile application or caused by the same. USER/YOU expressly admit that RSKPay is only a payment facilitator & intermediary, and as such, stands indemnified from any accountability that might arise because of the same. YOU (USER) moreover acknowledge that visiting/using RSKPay website/mobile application is an implicit reception/confirmation of this disclaimer on your part.',
      'YOU are requested to go through the merchant/vendor provided terms and conditions on their website and or platform. RSKPay is not responsible for your inability to access such terms and conditions or for any loss resulting from such terms and conditions or lack thereof. YOU agree and acknowledge that the actual contract for sale is directly between YOU and the merchant/vendor. RSKPay does not control or prevent changes in the published details and descriptions of websites/apps operated by the aggregator or the merchant/vendor and is not responsible for any content therein. RSKPay has no control over the existence, quality, safety or legality of items displayed; the accuracy of the aggregator\'s content or listings; the ability of the aggregator and merchant/vendor to sell items or provide services. RSKPay does not at any point of time during any transaction between YOU and aggregator/merchant/vendor, take the ownership of any of the listing, bookings or services offered by the aggregator/merchant/vendor. Nor does RSKPay at any point asserts any rights or claims over the same offered by the aggregator/merchant/vendor to YOU. The aggregator or the merchant/vendor is solely responsible for the content/listings/bookings made available by it through the RSKPay platform and YOU should contact the respective aggregator or merchant/vendor directly. For more information, we request YOU to contact the vendor/merchant/ service provider in order to get further clarifications and confirmation or the same can be confirmed on their websites as well.',
      'RSKPay is not a warrantor of the content/listings/bookings/services being offered on RSKPay by various aggregators or merchant/vendors. YOU understand that any issue or disputes regarding the warranty, guarantee, quality, and service will be addressed as per the terms and conditions of the aggregator or the merchant/vendors, and YOU agree to handle such issues and disputes directly between YOU and the aggregator or merchant/vendor.',
      'RSKPay is not responsible for any warranty, guarantee, post sale claims, genuineness of listings/bookings, content, products and services. RSKPay will not be liable for any claims including but not limited to any misrepresentation by the aggregator or the merchant/vendor in its content/listings/bookings.',
      'Notwithstanding anything contrary contained herein, the service, the interface and api work, and their respective information, pricing and data, and availability are subject at any time and from time to time to human, mechanical , typographic, or other errors, oversights, mistakes, limitations, delays, service interruptions, including, without limitation, as may be due in whole or in part to, related to or arising out of (i) computer hardware and software, telecommunication and operating systems, databases, or business processes and procedures, other problems inherent in, or which may be associated with, the use of the internet and electronic communications including, without limitation, force majeure event , government / regulatory actions, orders, notifications etc. And / or and acts and omissions of third parties etc.',
      'Any amount transferred erroneously or for any reason by the USER shall not be refunded to the USER in any circumstances.',
      'The USER understands and agrees that RSKPay is not a party to the contract between the USER and the merchant establishment. RSKPay does not endorse any advertiser or merchant linked to its website. Furthermore, RSKPay is under no obligation to monitor the merchant establishment`s service/products used by the USER. The merchant establishment alone will be responsible for all obligations under the contract including (without limitation) warranties or guarantees. Any dispute with or complaint against any merchant establishment must be directly resolved by the USER with the merchant establishment. It is clarified that RSKPay shall not be responsible or liable for any deficiency in goods and/or services purchased using RSKPay wallet.',
      'Any payment made erroneously by the USER to any merchant establishment or any erroneous transfer to any person shall not be refunded to the USER by RSKPay in any circumstances.',
      'Any web-link on the platform to a third party site is not an endorsement of that web-link. By using or browsing any such other web-link, the USER shall be subject to the terms and conditions in relation to that web-link.',
      'In the event of any dispute (defined below), RSKPay records shall be binding as the conclusive evidence of the transactions carried out through use of the wallet.',
      'RSKPay will not be responsible for recovering the money in case the account holder initiates fund transfer to an unintended or incorrect account.',
      'These following terms and conditions shall be applicable to the provision of any fund transfer and fund collection facility provided / facilitated by RSKPay. The USER shall provide correct beneficiary details to RSKPay at the time of availing the said facility. The USER shall be solely responsible for entering wrong beneficiary details like incorrect virtual payment address or incorrect mobile number or account no or ifsc code, due to which the fund are transferred to an incorrect beneficiary. The USER agrees that the payment order shall become irrevocable when it is executed by RSKPay.',
      'The USER is responsible for the accuracy and authenticity of the instructions provided to RSKPay and the same, if is in the form and manner prescribed by RSKPay, shall be considered to be sufficient to operate the said facility. RSKPay shall not be required to independently verify the instructions. RSKPay has no liability if it does not or is unable to stop or prevent the implementation of any payment order issued by the USER. Once a payment order is issued by the USER the same cannot be subsequently revoked by the USER.',
      'All instructions, requests, directives, orders, directions, entered by the USER, are based upon the USER\'s decisions and are the sole responsibility of the USER.',
      'Refunds (if any) will be credited to your RSKPay wallet account.'
    ]
  },
  {
    title: 'E Commerce Refund Policy',
    content: [
      '1. Return & Refund Policy',
      '',
      'Eligible Products: Applies only to electronics such as earbuds, smartwatches, headphones, and similar items.',
      '',
      'Return Window: Returns must be initiated within 7 days of delivery.',
      '',
      'Return Conditions:',
      '• Product must be unused and in original packaging with all accessories.',
      '• Must be eligible for resale (no scratches, tampering, or damage).',
      '• Device must turn on and pass basic tests (if applicable).',
      '',
      'Refund Process:',
      '• RSKPay arranges reverse pickup once return is approved.',
      '• Refunds are processed within 7-10 business days to the original payment method.',
      '• Shipping charges are non-refundable unless it\'s a RSKPay error (wrong/damaged item).',
      '',
      'Exchanges:',
      '• Only if stock is available.',
      '• Shipping costs may apply unless due to defect or wrong delivery.',
      '• All return conditions apply to exchanges as well.',
      '',
      'Damaged/Defective Items:',
      '• Must be reported within 24 hours to admin@rskonlineservices.com',
      '• Include clear photos and issue description.',
      '• Replacement sent free of charge after inspection and approval.',
      '',
      'Return Process Steps:',
      '1. Go to "My Orders" in the RSKPay app.',
      '2. Tap "Request Return/Refund"',
      '3. Select a reason and upload photos if required.',
      '4. Once approved, pickup/drop instructions will be shared.',
      '5. Post inspection, refund or replacement will be processed.',
      '',
      'Non-Returnable Items:',
      '• Used or damaged items',
      '• Products with opened hygiene seals (e.g., ear tips)',
      '• Items missing parts or accessories',
      '• Bulk/custom orders unless defective',
      '• Discount bundles or special offers (unless defective)'
    ]
  },
  {
    title: 'Shipping & Delivery Policy',
    content: [
      'Delivery Timeline: Standard delivery within 2-7 business days, depending on location.',
      '',
      'Shipping Partners: Orders shipped via trusted partners like Bluedart, Dtlivery, DTDC, etc.',
      '',
      'Shipping Charges:',
      '• Free shipping on orders above ₹499',
      '• Orders below ₹499 may carry a flat shipping fee (e.g. ₹49).',
      '',
      'Order Tracking: Customers can track orders live from "My Orders" in the app',
      '',
      'Failed Delivery: If the customer is unavailable, the courier will attempt redelivery or contact the customer.'
    ]
  },
  {
    title: 'Order Cancellation Policy',
    content: [
      'When You Can Cancel: Orders can be cancelled before they are shipped.',
      '',
      'How to Cancel:',
      '1. Go to "My Orders"',
      '2. Tap "Cancel Order"',
      '',
      'Post-Shipping Cancellation: If already shipped, cancellation is not possible. You can request a return instead after delivery.',
      '',
      'Refunds After Cancellation: If paid in advance, the refund will be processed to the original payment method within 5-7 business days.'
    ]
  },
  {
    title: 'Payment & Pricing Policy',
    content: [
      'Accepted Payment Methods:',
      '• UPI (PhonePe, GPay, Paytm, etc.)',
      '• Debit/Credit Cards',
      '• Net Banking',
      '• COD is Not Available for this Time',
      '',
      'Pricing Accuracy: RSKPay strives for accuracy but reserves the right to cancel orders in case of pricing or stock errors.',
      '',
      'GST & Taxes: All prices are inclusive of GST unless mentioned otherwise.',
      '',
      'Order Confirmation: You will receive a confirmation email/SMS once your order is placed successfully.'
    ]
  },
  {
    title: 'Warranty Policy (for electronics only)',
    content: [
      'Warranty Coverage:',
      '• Manufacturing defects',
      '• Issues with performance (not physical damage)',
      '',
      'Warranty Period: As specified on the product page (e.g., 6 months or 1 year)',
      '',
      'Claim Process:',
      '• Contact RSKPay or the brand directly with invoice & defect description',
      '• Warranty will not cover accidental damage, water exposure, or misuse'
    ]
  },
  {
    title: 'Customer Support Policy',
    content: [
      'Support Hours: Available Monday to Saturday – 10:00 AM to 7:00 PM (IST)',
      '',
      'Contact Channels:',
      '• Email: admin@rskonlineservices.com',
      '• In-app support section',
      '',
      'Response Time: All support tickets are replied to within 24–48 hours (excluding Sunday & public holidays)',
      '',
      'Address: 649 Harikrupa Appartment, Old Bagadganj, Nagpur - 440008',
      '',
      'Developed by: RSK Online Services PVT.LTD.'
    ]
  }
];

function RefundPolicySection() {
  const [activeSection, setActiveSection] = useState(0);

  return (
    <section id="refund-policy" className="refund-policy">
      <div className="refund-container">
        <h1>
          <span>Refund</span>
          <span className="text-gradient"> Policy</span>
        </h1>
        
        <div className="refund-content">
          <div className="refund-accordion">
            {refundPolicyData.map((section, index) => (
              <div key={index} className="refund-item">
                <button
                  className={`refund-header ${activeSection === index ? 'active' : ''}`}
                  onClick={() => setActiveSection(activeSection === index ? -1 : index)}
                >
                  {section.title}
                  <span className={`refund-toggle ${activeSection === index ? 'active' : ''}`}>
                    <FaChevronDown />
                  </span>
                </button>
                
                {activeSection === index && (
                  <div className="refund-body">
                    {section.content.map((paragraph, pIndex) => (
                      <p key={pIndex} className="refund-paragraph">
                        {paragraph}
                      </p>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default RefundPolicySection;